import {validateInput} from '@/drc/services/validation.service'
export {validateInput} from '@/drc/services/validation.service'
export let newsletter = {
	displayOrder: 0,
	id: null,
	isActive: true,
	message: "",
	platform: "",
	redirectUrl: "",
	redirectionButtonText: "",
	title: "",
	topic: "",
}

export const validations = {
	message: {min: 1, max: 500},
	redirectUrl: {min: 1, max: 3000, checkUrl: true},
	redirectionButtonText: {min: 1, max: 40},
	title: {min: 1, max: 255},
	topic: {min: 1, max: 50}
}

export function validateForm(newsletter) {
	const errors = [];
	for (const field of Object.keys(validations)) {
		errors.push(validateInput(newsletter[field], validations[field]));
	}

	return errors.filter(error => error.length !== 0);
}
